// src/store/index.jsx
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import authapi from '@/app/services/authAPI';
import authReducer from '@/app/slice/authSlice';
import commonapi from '@/app/services/commonAPI';
import authManualapi from '@/app/services/authManualAPI';
import studentRegistrationapi from '@/app/services/studentRegistrationAPI';
import dashboardapi from '@skillPassport/app/services/DashboardAPI';

import {
  locationAPI,
  externalSkillPassportAPI,
  passwordVerificationAPI,
  GovAnnouncementAPI,
  CommonAPI,
  profileAPI,
  contactUpdateAPI
} from "@gyandiksha/shared-ui/app/services";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authapi.reducerPath]: authapi.reducer,
    [authManualapi.reducerPath]: authManualapi.reducer,
    [commonapi.reducerPath]: commonapi.reducer,
    [studentRegistrationapi.reducerPath]: studentRegistrationapi.reducer,
    [dashboardapi.reducerPath]: dashboardapi.reducer,
    [locationAPI.reducerPath]: locationAPI.reducer,
    [externalSkillPassportAPI.reducerPath]: externalSkillPassportAPI.reducer,
    [passwordVerificationAPI.reducerPath]: passwordVerificationAPI.reducer,
    [GovAnnouncementAPI.reducerPath]: GovAnnouncementAPI.reducer,
    [CommonAPI.reducerPath]: CommonAPI.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [contactUpdateAPI.reducerPath]: contactUpdateAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      authapi.middleware,
      authManualapi.middleware,
      commonapi.middleware,
      studentRegistrationapi.middleware,
      dashboardapi.middleware,
      locationAPI.middleware,
      externalSkillPassportAPI.middleware,
      passwordVerificationAPI.middleware,
      GovAnnouncementAPI.middleware,
      CommonAPI.middleware,
      profileAPI.middleware,
      contactUpdateAPI.middleware,
    ),
});
setupListeners(store.dispatch);

